/** @jsx jsx */
import { useSelector } from 'react-redux'
import { Box, BoxProps } from '@material-ui/core'
import { jsx } from '@emotion/core'
import { AgentStatus, AccountStatus, Agent } from '@smartsupp/websocket-client-visitor'

import { agentsSelectors } from 'store/agent/index'
import { NUMBER_OF_OFFLINE_AVATARS_SHOWN } from 'constants/chatHeaderConstants'
import styled from 'styles/styled'

import AgentAvatar from 'components/shared/AgentAvatar'

type Props = {
	className?: string
	triggerVersion?: boolean
} & BoxProps

const renderAvatar = (agents: Agent[], joinedAgents: Agent[], widgetStatus: AccountStatus, className?: string) => {
	const possibleScenarios = [
		{
			joinedAgents: false,
			widgetOnline: false,
			agents: agents.slice(0, NUMBER_OF_OFFLINE_AVATARS_SHOWN),
		},
		{
			joinedAgents: true,
			widgetOnline: false,
			agents: joinedAgents.slice(0, NUMBER_OF_OFFLINE_AVATARS_SHOWN),
		},
		{
			joinedAgents: true,
			widgetOnline: true,
			agents: joinedAgents.slice(0, NUMBER_OF_OFFLINE_AVATARS_SHOWN),
		},
		{
			joinedAgents: false,
			widgetOnline: true,
			agents: agents.filter(a => a.status === AgentStatus.Online).slice(0, NUMBER_OF_OFFLINE_AVATARS_SHOWN),
		},
	]

	const isWidgetOnline = widgetStatus === AccountStatus.Online
	const areAgentsJoined = joinedAgents.length > 0

	const currentScenario = possibleScenarios.find(
		s => s.joinedAgents === areAgentsJoined && s.widgetOnline === isWidgetOnline,
	)!

	return currentScenario.agents.map(agent => (
		<div key={agent.id} className="multipleAvatarGrid">
			<AgentAvatar className={className} data-testid="avatarImage" src={agent.avatar} />
		</div>
	))
}

const Avatar = ({ className, ...rest }: Props) => {
	const agents = useSelector(agentsSelectors.getFilteredAgents)
	const joinedAgents = useSelector(agentsSelectors.getReversedJoinedAgents)
	const widgetStatus = useSelector(agentsSelectors.getWidgetStatus)

	return (
		<Box {...rest} className={className}>
			{renderAvatar(agents, joinedAgents, widgetStatus, className)}
		</Box>
	)
}

export const AvatarSection = styled(Avatar)`
	.multipleAvatarGrid {
		&:nth-of-type(n + 2) {
			margin-left: ${props => (props.triggerVersion ? '-10px;' : ' -17px;')};
		}

		&:nth-of-type(1) {
			z-index: 3;
		}

		&:nth-of-type(2) {
			z-index: 2;
		}

		&:nth-of-type(3) {
			z-index: 1;
		}

		&:hover {
			z-index: 4;
		}
	}
`
